import ActionTypes from "./ActionTypes";

const getNotification = (payload) => {
  return {
    type: ActionTypes.GET_NOTIFICATIONS,
    payload,
  };
};

const setNotificationCount = (payload) => {
  return {
    type: ActionTypes.GET_UNREAD_NOTIFICATIONS,
    payload,
  };
};

export { getNotification, setNotificationCount };
